import { useHistory } from 'react-router-dom';
import ModalBackdrop from './ModalBackdrop';  
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
// import './styles.scss';

interface ContinueOnboardingModalProps {
  onClose: () => void;
}

const ContinueOnboardingModal = (props: ContinueOnboardingModalProps) => {
  const history = useHistory();
  const onSubmit = () => {
    history.push(`/forms?formType=newPatient`);
  };

  return (
    <ModalBackdrop>
      <Dialog 
        open={true}
        PaperProps={{ sx: { padding: '22px 32px' } }}
      >
        <DialogTitle fontWeight="bold" sx={{ textAlign: 'center' }}>Complete Paperwork</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1 }}>
          <p>Before your appointment, you need to answer a few more questions.</p>
          <p>These questions are just like those you would answer when visiting an in-person doctors office (the forms on the clipboard!).</p>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => onSubmit()}
          >
            Continue to forms
          </Button>
          <Button
            variant="text"
            onClick={props.onClose}
          >
            Finish later
          </Button>
        </DialogActions>
      </Dialog>
    </ModalBackdrop>
  );
};

export default ContinueOnboardingModal; 